import { render, staticRenderFns } from "./TruncatedText.vue?vue&type=template&id=23988d43"
import script from "./TruncatedText.vue?vue&type=script&lang=js"
export * from "./TruncatedText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports